export default "__VITE_ASSET__9vkVXa0H__"